import classNames from 'classnames'
import {memo, useCallback, useContext} from 'react'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'

import type {BuildTypeId} from '../../../../../../../../types'
import type {CommiterSelectQuery} from '../../../../../../../common/UserSelect/__generated__/CommiterSelectQuery.graphql'
import CommiterSelect from '../../../../../../../common/UserSelect/CommiterSelect'
import type {UserSelectSelectedItem} from '../../../../../../../common/UserSelect/UserSelect.types'
import {useChangesFilter} from '../../../../../../../packages/Changes/Changes.hooks'
import ChangesContentFilter from '../../../../../../../packages/Changes/ChangesContentFilter/ChangesContentFilter'
import {PipelinesTargetContext, PipelinesTarget} from '../../../../../contexts/targetContext'

import ViewToggle from './ViewToggle/ViewToggle'

import styles from './ChangesFilter.css'

type Props = {
  className?: string
  buildTypeId?: BuildTypeId
  commiterSelectQueryRef: PreloadedQuery<CommiterSelectQuery>
}

function ChangesFilter({className, buildTypeId, commiterSelectQueryRef}: Props) {
  const pipelineTarget = useContext(PipelinesTargetContext)
  const {filterOptions, onChangeFilter} = useChangesFilter(buildTypeId)

  const onChangeUsername = useCallback(
    (data: UserSelectSelectedItem) => onChangeFilter({username: data?.value ?? null}),
    [onChangeFilter],
  )

  return (
    <div
      className={classNames(className, styles.changesFilter, {
        [styles.jobDetailsPopupTarget]: pipelineTarget === PipelinesTarget.JOB_DETAILS_POPUP,
      })}
      data-test-changes-filter
    >
      <div className={styles.line}>
        <CommiterSelect
          className={classNames(styles.filterControl, styles.commiterSelect)}
          buttonClassName={styles.commiterSelectButton}
          queryRef={commiterSelectQueryRef}
          selected={filterOptions.username}
          onChange={onChangeUsername}
        />
        <ViewToggle className={styles.filterControl} />
      </div>
      <div className={styles.line}>
        <ChangesContentFilter
          className={classNames(styles.filterControl, styles.changesContentFilter)}
          revision={filterOptions.revision}
          comment={filterOptions.comment}
          path={filterOptions.path}
          onChangeFilter={onChangeFilter}
        />
      </div>
    </div>
  )
}

export default memo(ChangesFilter)
